import type { AuthRepository, LoginResponse } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type LoginInput = {
	email: string;
	password: string;
};

export type LoginUseCase = UseCase<LoginInput, LoginResponse>;

export function loginBuilder(authRepository: AuthRepository): LoginUseCase {
	return async function login(input: LoginInput): Promise<LoginResponse> {
		const email = stringValueObject().validate('email', input.email);
		const password = stringValueObject().validate('password', input.password);

		return authRepository.login({
			email,
			password
		});
	};
}
